import { deviceTypes } from "src/helper/constants"

export const deviceGeneralTelemetries = () => ({
  onMessage: (message, meta) => {
    // Todo: handle general telemetries
  }
})